// Blog post content - modular structure
// Each blog post is in its own file for better maintainability

import debuggingWithFiddlerIsNotEnough from './debugging-with-fiddler-is-not-enough-how-to-prevent-api-meltdowns';
import foundTheBugInFiddler from './found-the-bug-in-fiddler-heres-how-to-test-it-under-real-load';
import howDevOpsTeamsUseApiLoadTesting from './how-devops-teams-use-api-load-testing-to-reduce-incidents';
import apiLoadTestingWithoutJmeter from './api-load-testing-without-jmeter-a-better-approach';
import bestAlternativesToJmeter from './best-alternatives-to-jmeter-for-api-load-testing';
import noCodeApiLoadTesting from './no-code-api-load-testing-how-alt-helps-teams-move-faster';
import loadTestRestApiUnder10Minutes from './load-test-rest-api-under-10-minutes';
import holidayTrafficApiPerformance from './holiday-traffic-api-performance-no-excuses';
import detectPerformanceRegressions from './detect-performance-regressions-before-users-do';
import scale100To100000Users from './scale-100-to-100000-users-without-performance-surprises';
import loadTestingProtectsRevenue from './load-testing-protects-revenue-high-traffic';
import holidayTrafficLoadTestingGuide from './holiday-traffic-load-testing-guide';
import beginnersGuideToLoadTesting from './beginners-guide-to-load-testing-apis';
import whenToUseRampUpLoadProfile from './when-to-use-ramp-up-load-profile-in-load-testing';
import whyLoadTestingIsMoreImportant from './why-load-testing-is-more-important-now-than-ever';
import howManyUsersCanYourApiHandle from './how-many-users-can-your-api-really-handle';

// Aggregate all blog posts into a single object for easy import
const blogPostsContent = {
    'debugging-with-fiddler-is-not-enough-how-to-prevent-api-meltdowns': debuggingWithFiddlerIsNotEnough,
    'found-the-bug-in-fiddler-heres-how-to-test-it-under-real-load': foundTheBugInFiddler,
    'how-devops-teams-use-api-load-testing-to-reduce-incidents': howDevOpsTeamsUseApiLoadTesting,
    'api-load-testing-without-jmeter-a-better-approach': apiLoadTestingWithoutJmeter,
    'best-alternatives-to-jmeter-for-api-load-testing': bestAlternativesToJmeter,
    'no-code-api-load-testing-how-alt-helps-teams-move-faster': noCodeApiLoadTesting,
    'load-test-rest-api-under-10-minutes': loadTestRestApiUnder10Minutes,
    'holiday-traffic-api-performance-no-excuses': holidayTrafficApiPerformance,
    'detect-performance-regressions-before-users-do': detectPerformanceRegressions,
    'scale-100-to-100000-users-without-performance-surprises': scale100To100000Users,
    'load-testing-protects-revenue-high-traffic': loadTestingProtectsRevenue,
    'holiday-traffic-load-testing-guide': holidayTrafficLoadTestingGuide,
    'beginners-guide-to-load-testing-apis': beginnersGuideToLoadTesting,
    'when-to-use-ramp-up-load-profile-in-load-testing': whenToUseRampUpLoadProfile,
    'why-load-testing-is-more-important-now-than-ever': whyLoadTestingIsMoreImportant,
    'how-many-users-can-your-api-really-handle': howManyUsersCanYourApiHandle,
};

export default blogPostsContent;
